import { cn } from "@/lib/cn";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { type ComponentPropsWithoutRef, type ElementRef, type ReactNode, forwardRef } from "react";

export const Drawer = DialogPrimitive.Root;
export const DrawerTrigger = DialogPrimitive.Trigger;

export const DrawerContent = forwardRef<
  ElementRef<typeof DialogPrimitive.Content>,
  ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & { title: ReactNode }
>(({ className, title, children, ...props }, ref) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/40" />
    <DialogPrimitive.Content
      ref={ref}
      aria-describedby={undefined}
      className={cn(
        "fixed right-0 top-0 z-50 flex h-screen w-[640px] flex-col border-l border-border bg-bg shadow-xl",
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:slide-in-from-right-full data-[state=closed]:slide-out-to-right-full",
        className,
      )}
      {...props}
    >
      <div className="flex items-center justify-between border-b border-border px-5 py-3">
        <DialogPrimitive.Title className="text-sm font-medium">{title}</DialogPrimitive.Title>
        <DialogPrimitive.Close aria-label="Close" className="text-fg-muted hover:text-fg">
          <X size={16} />
        </DialogPrimitive.Close>
      </div>
      <div className="flex-1 overflow-auto">{children}</div>
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
));
DrawerContent.displayName = "DrawerContent";
